import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WhatsAppFloatingWidget = ({ onWhatsAppClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    "🎮 Need help choosing a game?",
    "💰 Want to know about bonuses?",
    "🏆 Ready to start winning?",
    "📱 Get instant game access!",
    "🎯 Speak to gaming expert now!"
  ];

  useEffect(() => {
    // Show widget after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Cycle through messages
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages?.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [messages?.length]);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello! I'm interested in Nitin Online Hub gaming services. I'd like to know more about the available games and how to get started."
    );
    window.open(`https://wa.me/917704070169?text=${message}`, '_blank');
    if (onWhatsAppClick) onWhatsAppClick();
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Main Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="relative">
          {/* Expanded Message Bubble */}
          {isExpanded && (
            <div className="absolute bottom-16 right-0 mb-2 w-64 bg-white rounded-card border border-border shadow-royal p-4 animate-in slide-in-from-bottom-2">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="MessageCircle" size={20} color="white" />
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-text-primary text-sm mb-1">
                    Gaming Expert Online
                  </h4>
                  <p className="text-text-secondary text-xs mb-3">
                    {messages?.[messageIndex]}
                  </p>
                  <Button
                    variant="default"
                    size="sm"
                    onClick={handleWhatsAppClick}
                    iconName="MessageCircle"
                    iconPosition="left"
                    fullWidth
                    className="bg-green-500 hover:bg-green-600 text-white"
                  >
                    Start Chat
                  </Button>
                </div>
                <button
                  onClick={() => setIsExpanded(false)}
                  className="text-text-muted hover:text-text-primary"
                >
                  <Icon name="X" size={16} />
                </button>
              </div>
            </div>
          )}

          {/* Floating WhatsApp Button */}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="relative w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-royal hover:shadow-glow transition-royal flex items-center justify-center whatsapp-pulse"
          >
            <Icon name="MessageCircle" size={24} />
            
            {/* Notification Dot */}
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white rounded-full flex items-center justify-center text-xs font-bold animate-pulse">
              1
            </div>
            
            {/* Pulse Rings */}
            <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></div>
            <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-10" style={{ animationDelay: '0.5s' }}></div>
          </button>
        </div>
      </div>
      {/* Quick Action Buttons - Show when expanded */}
      {isExpanded && (
        <div className="fixed bottom-24 right-6 z-40 space-y-3">
          <button
            onClick={handleWhatsAppClick}
            className="flex items-center space-x-2 bg-white rounded-card border border-border shadow-subtle hover:shadow-royal transition-royal px-4 py-2 text-sm"
          >
            <Icon name="Gamepad2" size={16} color="var(--color-primary)" />
            <span className="text-text-primary">Browse Games</span>
          </button>
          
          <button
            onClick={handleWhatsAppClick}
            className="flex items-center space-x-2 bg-white rounded-card border border-border shadow-subtle hover:shadow-royal transition-royal px-4 py-2 text-sm"
          >
            <Icon name="HelpCircle" size={16} color="var(--color-accent)" />
            <span className="text-text-primary">Get Help</span>
          </button>
          
          <button
            onClick={handleWhatsAppClick}
            className="flex items-center space-x-2 bg-white rounded-card border border-border shadow-subtle hover:shadow-royal transition-royal px-4 py-2 text-sm"
          >
            <Icon name="Gift" size={16} color="var(--color-success)" />
            <span className="text-text-primary">Claim Bonus</span>
          </button>
        </div>
      )}
      {/* Backdrop for mobile */}
      {isExpanded && (
        <div 
          className="fixed inset-0 bg-black/20 z-30 lg:hidden"
          onClick={() => setIsExpanded(false)}
        />
      )}
    </>
  );
};

export default WhatsAppFloatingWidget;